module.exports = __webpack_public_path__ + "img/source_sw-item2.ab5647fa.png";